// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"3227fdd3","193":"796d3556","204":"d860f6d8","354":"6bfd0e99","453":"b136636e","566":"c67f8e62","741":"cc1b12d5","799":"07687e5e"}[chunkId] + ".chunk.js";
};